module.exports = __webpack_public_path__ + "static/media/campaign-by-category.44c97bf9.png";